/**
 * Plugin de Google Analytics 4 para Vue.js
 *
 * - En componentes: this.$trackEvent('nombre_evento', { parámetros })
 * - Fuera de componentes (services): import { trackEvent } from '@/plugins/analytics'
 */

import analyticsConfig from '@/config/analytics.config';

const { measurementId, debug } = analyticsConfig;
const active = analyticsConfig.enabled && !!measurementId;

function gtag() {
  window.dataLayer.push(arguments);
}

export function trackEvent(eventName, eventParams = {}) {
  if (debug) console.log('[Analytics]', eventName, eventParams);
  if (active) gtag('event', eventName, eventParams);
}

function pageTitle(route) {
  const title = route.meta.title || 'Perfil';
  return route.params.company ? `${title} | ${route.params.company}` : title;
}

export default {
  install(Vue, options = {}) {
    if (active) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      gtag('js', new Date());
      gtag('config', measurementId, analyticsConfig.config);
    } else {
      console.warn('[Analytics] Google Analytics no está habilitado o falta el Measurement ID');
    }

    Vue.prototype.$trackEvent = trackEvent;
    Vue.prototype.$trackPageView = (pagePath, title) =>
      trackEvent('page_view', { page_location: location.origin + pagePath, page_title: title });
    Vue.prototype.$trackClick = (elementName, elementCategory = 'engagement') =>
      trackEvent('click', { event_category: elementCategory, event_label: elementName });
    Vue.prototype.$trackSearch = (searchTerm) => trackEvent('search', { search_term: searchTerm });
    Vue.prototype.$trackShare = (method, contentType, itemId) =>
      trackEvent('share', { method, content_type: contentType, item_id: itemId });

    // Un único page_view por navegación (incluida la carga inicial).
    // afterEach corre antes de que el navegador actualice la URL, por eso se usa to.fullPath.
    if (options.router) {
      options.router.afterEach((to) => {
        // content_group queda fijado para todos los eventos siguientes: separa perfil vs news en los informes
        if (active) gtag('set', { content_group: to.path.startsWith('/news') ? 'news' : 'perfil' });
        trackEvent('page_view', {
          page_title: pageTitle(to),
          // Los enlaces compartidos llevan la noticia codificada en la URL: se agrupan en una sola página
          page_location: location.origin + (to.meta.isShared ? '/news/shared' : to.fullPath),
          content_type: to.meta.sourceType,
        });
      });
    }
  },
};
